/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/prefer-default-export
export enum Role {
  QUIZ_EDITOR = 'QUIZ_EDITOR' as any,
  MEMBER_EDITOR = 'MEMBER_EDITOR' as any,
  EVENT_EDITOR = 'EVENT_EDITOR' as any,
  MANAGER = 'MANAGER' as any,
  ADMIN = 'ADMIN' as any
}
